import { MODAL_TYPE_T } from "@Models/access";

const titles = {
  ACCESS_DENIED: "Acceso denegado",
  PLAN_LIMIT_REACHED: "Límite de plan alcanzado",
  FEATURE_LIMITED_REACHED: "¡Ups! Has alcanzado el límite de tu plan",
};

export const getAccessModalTitle = (modalType: MODAL_TYPE_T) => {
  return titles[modalType];
};
